export const API_ENDPOINTS = {
  MONITOR: {
    ENTITY: '/api/v1/monitor/getMonitorEntity',
    DEVICE: '/api/v1/monitor/getMonitorDIIOT'
  },
  REAL_TIME: {
    BASE: '/api/v1/realTime',
    CONSOLIDATED: '/api/v1/realTimeConsolidated/all'
  },
  FILE_REPORT: {
    GET_BY_DEVICE: '/api/v1/fileReport/getReportsByDevice',
    DOWNLOAD: '/api/v1/fileReport/downloadReport',
    DOWNLOAD_JSON: '/api/v1/fileReport/downloadJson',
    DOWNLOAD_PDF: '/api/v1/fileReport/downloadPdf',
    DELETE: '/api/v1/fileReport/deleteReport',
    CREATE_CALIDAD_ELECTRICA: '/api/v1/fileReport/calidadElectrica'
  },
  ENTITY: {
    CREATE: '/api/v1/entity/createEntity',
    UPDATE: '/api/v1/entity/updateEntity',
    GET: '/api/v1/entity/getEntity',
    DELETE_DIMENSIONS: '/api/v1/entity/deleteDimensions'
  },
  LOCALITY: {
    CREATE: '/api/v1/locality/createLocality',
    UPDATE: '/api/v1/locality/updateLocality',
    GET: '/api/v1/locality/getLocality'
  },
  GEOLOCATION: {
    GET_ALL: '/api/v1/geoLocation/getAll',
    GET_BY_FILTER: '/api/v1/geoLocation/getLocationByFilter'
  },
  WEB_SETTINGS: {
    TIME_ZONES: '/api/v1/webSettings/getTimeZones'
  },
  USER: {
    CREATE_OR_GET: '/api/v1/user/createGetUser',
    GET_ALL: '/api/v1/user/getUsers',
    GET: '/api/v1/user/getUser',
    UPDATE: '/api/v1/user/updateUser',
    UPDATE_MY_PROFILE: '/api/v1/user/updateMyProfile',
    ASSIGN_DEVICE: '/api/v1/user/assignUserDevice',
    ASSIGN_USERS_TO_ENTITY: '/api/v1/user/assignUsersToEntity',
    ASSIGN_DEFAULT_ENTITY: '/api/v1/user/assignDefaultEntity'
  },
  DEVICE: {
    CREATE: '/api/v1/device/createDevice',
    GET_CONFIG: '/api/v1/device/getConfig',
    GET_STATUS: '/api/v1/device/getStatus',
    UPDATE_CONFIG: '/api/v1/device/uploadConfig',
    UPDATE: '/api/v1/device/updateDevice',
    RESET: '/api/v1/device/resetDevice',
    FORMAT: '/api/v1/device/formatDevice'
  },
  EVENT: {
    UPLOAD_CUSTOM: '/api/v1/event/uploadCustomEvent',
    GET_ALL_CUSTOM: '/api/v1/event/getAllCustomEvents'
  },
  REPORTING: {
    HISTORICAL_DATA: '/api/v1/reporting/getHistoricalData',
    WEATHER_DATA: '/api/v1/reporting/getWeatherData',
    GET_EVENTS: '/api/v1/reporting/getEvents'
  },
  DEVICE_CHART: {
    GET: '/api/v1/deviceChart/getCharts',
    SAVE: '/api/v1/deviceChart/saveChart',
    REORDER: '/api/v1/deviceChart/reorderCharts',
    DELETE: '/api/v1/deviceChart/deleteChart'
  },
  ANALISIS_CONSUMO: {
    HISTORICAL_BUNDLE: '/api/v1/analisisConsumo/historicalBundle'
  }
};

export default API_ENDPOINTS;
